<div class="padding-right">
  <generic-form-header-section [title]="title()"></generic-form-header-section>
  @if (formReady()) {
    <app-questions-list-form
      [questions]="questions()"
      [formGroup]="formGroup"
      [readOnly]="readOnly()"
      (answersUpdated)="emitAnswersUpdated($event)"
      class="form-container"
    ></app-questions-list-form>
  }
</div>
